import { createAction } from '../ReduxUtils'
import { getStore } from '../Store'

export const JSNG_SELECTED = 'JSNG_SELECTED'

export interface JsngSelected {
    nameId: string;
}

export function selectJsng(nameId: string) {
	getStore().dispatch(createAction(JSNG_SELECTED, { nameId }))
}
